<template>
  <div class="row-wrap">
    <div class="link-wrap">
      <div class="fields">
        <div class="input-wrap">
          <label>Title:</label>
          <input type="text" :class="linkObj.stl_active ? 'active' : ''" placeholder="Add title..." v-model.trim="newLinkObj.stl_title" @blur="emitAction('edit-link')">
        </div>
        <div class="input-wrap">
          <label>Lecturer:</label>
          <input type="text" :class="linkObj.stl_active ? 'active' : ''" placeholder="Add lecturer..." v-model.trim="newLinkObj.stl_lecturer" @blur="emitAction('edit-link')">
        </div>
        <div class="input-wrap">
          <label>Link:</label>
          <input type="text" :class="linkObj.stl_active ? 'active' : ''" placeholder="Add link..." v-model.trim="newLinkObj.stl_link" @blur="emitAction('edit-link')">
        </div>
        <div class="input-wrap">
          <label>Duration:</label>
          <input type="text" :class="linkObj.stl_active ? 'active' : ''" placeholder="Hours:Minutes" v-model.trim="newLinkObj.stl_duration" @blur="emitAction('edit-link')">
        </div>
      </div>
      <div class="buttons">
        <div class="button-line">
          <input type="radio" 
            :checked="linkObj.stl_active" 
            :name="'radio' + newLinkObj.loc_id" 
            @change="emitAction('select-link', $event.target.checked)"
          >
          <span class="material-icons" @click="emitAction('confirm-delete')">delete</span>
        </div>
      </div>
    </div>
    <div class="separator"></div>
  </div>
</template>

<script>
let timeRegex = RegExp("^([0-9][0-9]):([0-5][0-9])$");
export default {
  props: {
    linkObj: Object
  },
  data () {
    return {
      newLinkObj: {
        ...this.linkObj
      }
    }
  },
  computed: {
    isValidDurationInput () {
      let isValid = true;
      if (this.newLinkObj.stl_duration) {
        isValid = this.newLinkObj.stl_duration.length !== 0 && timeRegex.test(this.newLinkObj.stl_duration)
      }
      return isValid;
    }
  },
  methods: {
    emitAction (action) {
      if (this.isValidDurationInput) {
        if (action === 'select-link') {
          this.newLinkObj.stl_active = this.newLinkObj.stl_active? 0 : 1;
        }
        if (action === 'confirm-delete') {
          this.$emit(action, this.newLinkObj)
        }
        for (const key in this.newLinkObj) {
          if (this.newLinkObj[key] !== this.linkObj[key]) {
            this.$emit(action, this.newLinkObj);
          }
        }
      } else {
        this.newLinkObj.stl_duration = this.linkObj.stl_duration;
        this.handleError(new Error("Invalid duration format."))
      }
    }
  },
  watch: {
    linkObj: {
      handler () {
        this.newLinkObj = { ...this.linkObj }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes click-wave {
  0% {
    height: 40px;
    width: 40px;
    opacity: 0.35;
    position: relative;
  }
  100% {
    height: 200px;
    width: 200px;
    margin-left: -80px;
    margin-top: -80px;
    opacity: 0;
  }
}
.row-wrap {
  display: flex;
  flex-direction: column;
  width: 90%;
  .separator {
    width: 100%;
    height: 2px;
    background: rgb(83, 83, 83);
    margin: 20px 0;
  }
}
.link-wrap {
  display:flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 1% 0 1% 5%;
  width: 100%;
  .fields {
    width: 70%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .buttons {
    display: flex;
    align-items: center;
    width: 30%;
    .button-line {
      width: 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }
  }
}
.input-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  > * {
    margin: 2px 0;
  }
}
.input-wrap input[type=text].active {
  border: 2px solid #21EB99;
}
.input-wrap input[type=text].active:focus {
  border: 3px solid #21EB99;
}
.input-wrap input[type=text]:focus {
  outline: none;
  border: 2px solid black
}
.input-wrap input[type=text]:active {
  outline: none;
}
.input-wrap input[type=text] {
  width: 80%;
  border: 1px solid black;
}
input[type=radio] {
  margin-left: 7%;
  appearance: none;
  position: relative;
  height: 40px;
  width: 40px;
  transition: all 0.15s ease-out 0s;
  background: white;
  border: none;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  outline: none;
}
input[type=radio]:hover {
  background: #E5E5E5;;
}
input[type=radio]:checked {
  background: #21EB99;
}
input[type=radio]:checked::before {
  height: 40px;
  width: 40px;
  position: absolute;
  content: '✔';
  display: inline-block;
  font-size: 26.66667px;
  text-align: center;
  line-height: 40px;
  left: 0;
}
input[type=radio] {
  border-radius: 50%;
}
input[type=radio]::after {
  border-radius: 50%;
}
.material-icons {
  cursor: pointer;
}
</style>